import { AxiosInstance, AxiosStatic } from 'axios'
import { ApiRoutesNames as ApiRoutesName } from 'bets.oddprovider.lib.common.ts/api/routes'
import { IEventStatus } from 'bets.oddprovider.lib.common.ts/models'
import { BaseApiClient } from 'fwork-jsts-common/src/apiClient'
import { FilterQuery } from 'mongoose'
import { store } from '../redux/store'

export class EventsStatusApiClient extends BaseApiClient<IEventStatus, any, FilterQuery<IEventStatus>, IEventStatus, IEventStatus> {
  constructor(axios: AxiosStatic | AxiosInstance) {
    const dotEnvProductionState = store.getState().dotEnvProductionState
    const baseUrl = `${dotEnvProductionState.payload?.APIURL}${ApiRoutesName.eventsStatus}`
    super({
      apiUrl: baseUrl,
      axios,
    })
  }
}